import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { getAppConfig } from './config'
import { installPlugins } from './installers'
import { useHallApi } from '@99fun-agent/hooks'
// import { useSiteStore } from '@99fun-agent/stores'
// 打印当前配置（同步获取）

const app = createApp(App)
const config = getAppConfig()
useHallApi().init(config.apiBaseUrl)
// const asyncInstall = async () => {
// 安装路由
app.use(router)

// 安装其他插件（i18n, pinia, etc.）
installPlugins(app)

// 挂载应用
app.mount('#app')
// const siteStore = useSiteStore()
// siteStore.getConfigs()
// }
// asyncInstall()

// console.group(`🚀 Application Started`)
// console.log(`📦 Project: ${config.projectName}`)
// console.log(`🔧 Mode: ${config.mode}`)
// console.log(`📋 Title: ${config.title}`)
// console.log(`🔗 API: ${config.apiBaseUrl}`)
// console.log(`💰 Currency: ${config.currency}`)
// console.log(`🌐 Language: ${config.defaultLang}`)
// console.log(`⏰ Timezone: ${config.timezone}`)
// console.log(`🗣️  Supported Languages: ${config.supportedLangs.join(', ')}`)

// // Logo 配置
// console.log(`🖼️  Logo URL: ${config.logoUrl || 'not set'}`)
// console.log(`📝 Logo Text: ${config.logoText || 'not set'}`)

// if (config.theme.primaryColor || config.theme.secondaryColor) {
//   console.log(`🎨 Theme:`, config.theme)
// }

// console.log(`⚡ Features:`, config.features)

// if (config.services.analyticsId || config.services.cdnUrl) {
//   console.log(`🔌 Services:`, config.services)
// }

// if (config.contact.supportEmail || config.contact.phoneNumber) {
//   console.log(`📞 Contact:`, config.contact)
// }

// console.groupEnd()

// // 在开发模式下打印完整配置
// if (config.mode === 'development') {
//   console.group('📄 Full Configuration')
//   console.log(config)
//   console.groupEnd()
// }
